
import { defineComponent, nextTick, onMounted, ref } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import axios from "axios";
import { useRoute, useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useCookies } from "vue3-cookies";
import jQuery from "jquery";
const $ = jQuery;
const video = ref();
const canvas = ref();
const captures = ref([] as Array<object>);
const listData = ref();
const page = ref(0);
const score = ref(0);
const answer = ref<any[]>([]);
const answersList = ref<Array<{ questionId: any; choiceId: any[]; answerUser: any }>>([]);
import router from "@/router";
const submitButton = ref(false);
const resultDialogVisible = ref(false);
const resultData = ref({
  passed: false,
  title: "",
  subtitle: "",
  totalQuestion: 0,
  totalScore: 0,
  percentPass: 0,
  timeSubmit: "",
  userScore: 0,
  percent: 0,
});
export default defineComponent({
  name: "exam-general-learn",
  components: {},
  data() {
    return {
      checkPermission: 0,
      timeInSecs: 0,
      ticker: 0,
      imageUrl: process.env.VUE_APP_IMG_URL,
      videoSkip: process.env.VUE_APP_VIDEO_SKIP === "true",
      countdown: "",
      calcDisplay: "0",
      calcExpression: "",
      calcHasResult: false,
      dataParams: this.$route.params,
      // eslint-disable-next-line no-undef
      localStream: {
        srcObject: "",
      },
      examRoomProfile: "",
      myExam: [],
      componentKey: 0,
    };
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const { cookies } = useCookies();
    const examQuestionKey = "ExamLearnQuestion_" + localStorage.getItem("u_id") + "_" + route.params.id;
    const timerKey = "ExamLearnTimer_" + localStorage.getItem("u_id") + "_" + route.params.id;
    onMounted(() => {
      answersList.value = [];
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      getDataList();
    });
    const getDataList = () => {
      const cached = localStorage.getItem(examQuestionKey);
      if (cached) {
        listData.value = JSON.parse(cached);
        const savedAnswers = localStorage.getItem("examLearnAnswersList_" + route.params.id);
        if (savedAnswers) {
          answersList.value = JSON.parse(savedAnswers);
         console.log(answersList.value);
         
          const restored: any[] = [];
          answersList.value.forEach((item) => {
            if (item.choiceId && item.choiceId.length > 0) {
              const idx = listData.value.findIndex((q) => q.id === item.questionId);
              if (idx !== -1) restored[idx] = item.choiceId[0];
            } else if (item.answerUser) {
              const idx = listData.value.findIndex((q) => q.id === item.questionId);
              if (idx !== -1) restored[idx] = item.answerUser;
            }
          });
          answer.value = restored as any;
        }
        return;
      }
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/getExamQuestion?examId=" +
            route.params.id,
          {
            headers: {
              token: localStorage.getItem("id_token")
            },
          }
        )
        .then((response) => {
          listData.value = response.data.data;
          if (listData.value.length == 0) {
            Swal.fire({
              title: "ไม่สามารถทำข้อสอบได้ !",
              text: "ไม่พบข้อมูลคำถามคำตอบกรุณาตรวจสอบข้อมูล",
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "ลองใหม่ภายหลัง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            }).then((result) => {
              router.go(-1);
            });
          } else {
            localStorage.setItem(examQuestionKey, JSON.stringify(listData.value));
          }
          // console.log(listData.value);
        })
        .catch((error) => {
          // console.log(error);
        });
    };
    const previousPage = () => {
      page.value = page.value - 1;
    };
    const nextPage = () => {
      page.value = page.value + 1;
    };
    const changePage = (event) => {
      page.value = event;
    };
    const setDataInArrayObjectById = (array, id, answer, type) => {
      const foundObject = array.find((obj) => obj.questionId === id);
      if (!foundObject) {
        return false;
      }
      if (type == 1) {
        foundObject["choiceId"] = [answer];
      } else {
        foundObject["choiceId"] = [];
        foundObject["answerUser"] = answer;
      }
    };
    const setAnswer = (qId, answer, type) => {
      /* eslint-disable */
      const list: any = {};
      if (answersList.value.length > 0) {
        if (
          setDataInArrayObjectById(answersList.value, qId, answer, type) ==
          false
        ) {
          if (type == 1) {
            list.questionId = qId;
            list.choiceId = [answer];
            list.answerUser = "";
          } else {
            list.questionId = qId;
            list.choiceId = [];
            list.answerUser = answer;
          }
        }
      } else {
        if (type == 1) {
          list.questionId = qId;
          list.choiceId = [answer];
          list.answerUser = "";
        } else {
          list.questionId = qId;
          list.choiceId = [];
          list.answerUser = answer;
        }
      }
      if (list.questionId) {
        answersList.value.push(list);
      }
      console.log("setAnswer:", JSON.parse(JSON.stringify(answersList.value)));
      localStorage.setItem("examLearnAnswersList_" + route.params.id, JSON.stringify(answersList.value));
    };
    return {
      getDataList,
      listData,
      page,
      previousPage,
      nextPage,
      answer,
      changePage,
      setAnswer,
      video,
      canvas,
      captures,
      route,
      answersList,
      setDataInArrayObjectById,
      submitButton,
      examQuestionKey,
      timerKey,
      cookies,
      resultDialogVisible,
      resultData,
    };
  },
  async mounted() {
    if (localStorage.getItem("reloaded")) {
      localStorage.removeItem("reloaded");
      this.componentKey += 1;
      page.value = 0
    }
    let exam = await axios.get(
      process.env.VUE_APP_API_URL + "/getExam?id=" + this.$route.params.id,
      {
        headers: {
          token: localStorage.getItem("id_token")
        },
      }
    );
    if (exam.data.data.content?.length > 0) {
      this.myExam = exam.data.data.content[0];
      setCurrentPageBreadcrumbs(this.myExam["title"], []);
      if (listData.value && listData.value.length > 0) {
        Swal.fire({
          title: "แบบทดสอบ",
          text:
            "ระบบจะจับเวลาและบันทึกการทำข้อสอบทันที เมื่อคุณกดปุ่มเริ่มทำข้อสอบ",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#323563",
          cancelButtonColor: "#d33",
          allowOutsideClick: false,
          confirmButtonText: "เข้าใจและเริ่มทำข้อสอบ",
          cancelButtonText: "กลับสู่หน้าหลัก",
        }).then(async (result) => {
          if (result.isConfirmed) {
            const savedTimer = localStorage.getItem(this.timerKey);
            const initSecs = savedTimer ? parseInt(savedTimer) : exam.data.data.content[0].limitTime * 60;
            this.startTimer(initSecs);
          } else {
            router.go(-1);
          }
        });
      }
    }
  },
  methods: {
    autoAnswer() {
      if (!listData.value) return;
      listData.value.forEach((question, idx) => {
        if (question.qType == 1 && question.questionChoices) {
          const correct = question.questionChoices.find((c) =>
            c.textChoice && c.textChoice.indexOf("ข้อนี้ถูก") !== -1
          );
          if (correct) {
            answer.value[idx] = correct.choiceId;
            this.setAnswer(question.id, correct.choiceId, 1);
          }
        }
      });
    },
    formatDate(date) {
      const event = new Date(date);
      return event.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
    formatDateTime(date) {
      const event = new Date(date);
      return (
        event.toLocaleDateString("th-TH", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }) + " น."
      );
    },
    startTimer(secs) {
      this.timeInSecs = parseInt(secs);
      this.ticker = window.setInterval(() => {
        this.tick();
      }, 1000);
    },
    tick() {
      var secs = this.timeInSecs;
      if (secs > 0) {
        this.timeInSecs--;
      } else {
        clearInterval(this.ticker);
        Swal.fire({
      title: "หมดเวลาทำข้อสอบแล้ว!",
      text: "ต้องการส่งคำตอบหรือไม่ ?",
      icon: "error",
      buttonsStyling: false,
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: "ส่งคำตอบ",
      cancelButtonText: "ยกเลิก",
      customClass: {
        confirmButton: "btn fw-semibold btn-primary btn-lg",
        cancelButton: "btn fw-semibold btn-light-danger btn-sm",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.submit()
      } else {
        this.$router.go(-1);
      }
    });
      }
      var mins = Math.floor(secs / 60);
      secs %= 60;
      var pretty =
        (mins < 10 ? "0" : "") + mins + ":" + (secs < 10 ? "0" : "") + secs;
      this.countdown = pretty;
      localStorage.setItem(this.timerKey, this.timeInSecs + "");
    },
    percentageToDegrees(percentage) {
      return (percentage / 100) * 360;
    },
    async submit() {
      Swal.fire({
        title: "ต้องการส่งคำตอบใช่หรือไม่",
        icon: "warning",
  buttonsStyling: false,
          allowOutsideClick: false,
          confirmButtonText: "ส่งคำตอบ",
          cancelButtonText: "ยกเลิก",
          customClass: {
            confirmButton: "btn fw-semibold btn-primary btn-lg",
            cancelButton: "btn fw-semibold btn-light-danger btn-sm",
          },
      }).then((result) => {
        if (result.isConfirmed) {
          submitButton.value = true;
          clearInterval(this.ticker);
          clearInterval(this.checkPermission);
          let timeSubmit = this.convertStoMs(
            this.myExam["limitTime"],
            this.countdown
          );
          let examId = this.$route.params.id;
          score.value = 0;
          axios
            .post(
              process.env.VUE_APP_API_URL + "/checkAnswer",
              answersList.value,
              {
                headers: {
                  token: localStorage.getItem("id_token")
                },
              }
            )
            .then((res) => {
              // console.log(this.myExam);
              score.value = res.data.data.score;
              const formData = new FormData();
              formData.append("score", score.value + "");
              formData.append("examId", examId + "");
              axios
                .post(process.env.VUE_APP_API_URL + "/updateScore", formData, {
                  headers: {
                    token: localStorage.getItem("id_token")
                  },
                })
                .then(async (res) => {
                  if (res.data.status == 400) {
                    Swal.fire({
                      title: "แจ้งเตือนข้อผิดพลาด",
                      text: res.data.message,
                      icon: "error",
                      buttonsStyling: false,
                      confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
                      customClass: {
                        confirmButton: "btn fw-semobold btn-light-danger",
                      },
                    });
                  }
                  submitButton.value = false;
                  localStorage.removeItem(this.examQuestionKey);
                  localStorage.removeItem(this.timerKey);
                  localStorage.removeItem("examLearnAnswersList_" + this.$route.params.id);
                  let percent = await this.formatNumber(
                    (score.value / listData.value.length) * 100
                  );

                  const passed = percent >= this.myExam["percentPass"];
                    // title: passed ? "ส่งคำตอบเรียบร้อยแล้ว" : "เสียใจด้วย คุณไม่ผ่านการทดสอบ",
                    // subtitle: passed
                    //   ? "โปรดติดต่อเจ้าหน้าที่ที่ดูแลการสอบ"
                    //   : "โปรดติดต่อเจ้าหน้าที่ เพื่อขอทำการทดสอบอีกครั้งโดยจะต้องทำการจองเพื่อขอสอบผ่านระบบเท่านั้น",
                  resultData.value = {
                    passed,
                    title: "ส่งคำตอบเรียบร้อยแล้ว",
                    subtitle: "",
                    totalQuestion: this.myExam["totalQuestion"],
                    totalScore: this.myExam["totalScore"],
                    percentPass: this.myExam["percentPass"],
                    timeSubmit,
                    userScore: score.value,
                    percent,
                  };
                  resultDialogVisible.value = true;
                })
                .catch((error) => {
                  // console.log(error);
                  Swal.fire({
                    title: "แจ้งเตือนข้อผิดพลาด",
                    text: error.message,
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
                    customClass: {
                      confirmButton: "btn fw-semobold btn-light-danger",
                    },
                  });
                });
            })
            .catch((error) => {
              submitButton.value = false;
              // console.log(error);
              Swal.fire({
                title: "แจ้งเตือนข้อผิดพลาด",
                text: error.message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
                customClass: {
                  confirmButton: "btn fw-semobold btn-light-danger",
                },
              });
            });
        }else{
          submitButton.value = false
        }
      });
    },
    calcClear() {
      this.calcDisplay = "0";
      this.calcExpression = "";
      this.calcHasResult = false;
    },
    calcInput(val: string) {
      const ops = ["+", "-", "*", "/"];
      if (val === "⌫") {
        if (this.calcHasResult) {
          this.calcDisplay = "0";
          this.calcExpression = "";
          this.calcHasResult = false;
          return;
        }
        this.calcDisplay = this.calcDisplay.length > 1 ? this.calcDisplay.slice(0, -1) : "0";
        return;
      }
      if (ops.includes(val)) {
        this.calcExpression = (this.calcHasResult ? this.calcDisplay : this.calcExpression + this.calcDisplay) + val;
        this.calcDisplay = "0";
        this.calcHasResult = false;
        return;
      }
      if (this.calcHasResult) {
        this.calcDisplay = val === "." ? "0." : val;
        this.calcExpression = "";
        this.calcHasResult = false;
        return;
      }
      if (val === "." && this.calcDisplay.includes(".")) return;
      this.calcDisplay = this.calcDisplay === "0" && val !== "." ? val : this.calcDisplay + val;
    },
    calcEqual() {
      try {
        const expr = this.calcExpression + this.calcDisplay;
        const result = Function('"use strict"; return (' + expr + ')')();
        this.calcDisplay = String(parseFloat(result.toFixed(10)));
        this.calcExpression = expr + "=";
        this.calcHasResult = true;
      } catch {
        this.calcDisplay = "Error";
        this.calcExpression = "";
        this.calcHasResult = true;
      }
    },
    formatNumber(score) {
      return parseInt(score);
    },
    convertStoMs(limit, countdown) {
      if (!countdown || !countdown.includes(":") || !limit) return "00 : 00";
      const parts = countdown.split(":");
      const remainSecs = parseInt(parts[0]) * 60 + parseInt(parts[1]);
      const usedSecs = parseInt(limit) * 60 - remainSecs;
      if (isNaN(usedSecs) || usedSecs < 0) return "00 : 00";
      let minutes: any = Math.floor(usedSecs / 60);
      let extraSeconds: any = usedSecs % 60;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      extraSeconds = extraSeconds < 10 ? "0" + extraSeconds : extraSeconds;
      return minutes + " : " + extraSeconds;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    beforeUnmount() {
      submitButton.value = false
      localStorage.setItem("reloaded", "1");
      clearInterval(this.ticker);
    },
  },
});
